export const getTotalMeasuredCostsYear1 = (value) => {
  return {
    type: "GET_TOTAL_MEASURED_COSTS_YEAR_1",
    payload: value,
  };
};
export const getTotalMeasuredCostsYear2 = (value) => {
  return {
    type: "GET_TOTAL_MEASURED_COSTS_YEAR_2",
    payload: value,
  };
};
export const getTotalMeasuredCostsYear3 = (value) => {
  return {
    type: "GET_TOTAL_MEASURED_COSTS_YEAR_3",
    payload: value,
  };
};
